import DataWarehouseServices from "./DataWarehouseServices";
import RelatedControlMeasures from "./RelatedControlMeasures";

const IDataMappingServices = {
  ...DataWarehouseServices,
  ...RelatedControlMeasures,
};

export default IDataMappingServices;
